import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVsic from '../../../../../../common/category/useGetVsic'
import { Element } from '../../../../../../common/html/element'
import { Loading } from '../../../../../../common/loading'
import { Notification } from '../../../../../../common/notification'
import { FORMAT, formatDateTime } from '../../../../../../helpers/datetime'
import {
  selectCompareIndustry,
  selectDefaultIndustry,
} from '../../../store/slice'
import { selectCommentaryData, selectLoading } from '../../store/slice'
import classes from './index.module.scss'

const Commentary = ({ isDynamicReport, settingDynamic = {} }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading('commentary'))
  const commentaryData = useSelector(selectCommentaryData)
  const vsicDefaultStore = useSelector(selectDefaultIndustry)
  const vsicCompareStore = useSelector(selectCompareIndustry)
  const { vsics } = useGetVsic()

  const { DEFAULT_INDUSTRY: vsicDefaultDyn, COMPARE_INDUSTRY: vsicCompareDyn } =
    settingDynamic

  const vsicDefault = isDynamicReport ? vsicDefaultDyn : vsicDefaultStore
  const vsicCompare = isDynamicReport ? vsicCompareDyn : vsicCompareStore

  const titleDefaultIndustry = vsics.find(
    (item) => item.id === vsicDefault,
  )?.name
  const titleComparingIndustry = vsics.find(
    (item) => item.id === vsicCompare,
  )?.name

  return (
    <div
      className={classes.bgComponent}
      style={{ marginTop: isDynamicReport ? 0 : 36 }}
    >
      <Element style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>
        <Translate value="companyAnalysis.industryAnalysis.COMMENTARY" />
      </Element>
      {loading ? (
        <div style={{ height: 100 }}>
          <Loading />
        </div>
      ) : (
        <div className={`dFlex ${isDynamicReport ? 'gap1' : 'gap4'}`}>
          <div
            className={`${classes.boxDefaultIndustry} ${
              !!vsicCompare ? 'w50' : 'w100'
            }`}
          >
            <div className={classes.header}>{titleDefaultIndustry}</div>
            <div className={classes.body}>
              {!commentaryData?.default?.publicDate &&
              !commentaryData?.default?.content ? (
                <div style={{ height: 100, position: 'relative' }}>
                  <Notification />
                </div>
              ) : (
                <ul>
                  <li>
                    <Translate
                      value="companyAnalysis.industryAnalysis.LAST_UPDATED_DATE"
                      date={formatDateTime(
                        commentaryData?.default?.publicDate,
                        FORMAT.DATE,
                        locale,
                      )}
                    />
                  </li>
                  <li>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: commentaryData?.default?.content,
                      }}
                    />
                  </li>
                </ul>
              )}
            </div>
          </div>
          {!!vsicCompare && (
            <div className={classes.boxComparingIndustry}>
              <div className={classes.header}>{titleComparingIndustry}</div>
              <div className={classes.body}>
                {!commentaryData?.compare?.publicDate &&
                !commentaryData?.compare?.content ? (
                  <div style={{ height: 100, position: 'relative' }}>
                    <Notification />
                  </div>
                ) : (
                  <ul>
                    <li>
                      <Translate
                        value="companyAnalysis.industryAnalysis.LAST_UPDATED_DATE"
                        date={formatDateTime(
                          commentaryData?.compare?.publicDate,
                          FORMAT.DATE,
                          locale,
                        )}
                      />
                    </li>
                    <li>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: commentaryData?.compare?.content,
                        }}
                      />
                    </li>
                  </ul>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Commentary
